import { useEffect, type ReactElement, type ReactNode } from 'react';
import { useLocation } from 'react-router';

interface ScrollToTopProps {
	children: ReactNode;
}

function ScrollToTop({ children }: ScrollToTopProps): ReactElement {
	const location = useLocation();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [location.pathname]);

	return <>{children}</>;
}

export default ScrollToTop;
